import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-PremierPL-react';
import 'gw-capability-policychange-common-react';
import 'premier-capability-policychange-common-react';
import PLPolicyChangesPage from './pages/PLPolicyChanges/PLPolicyChangesPage';

setComponentMapOverrides(
    {
        PremierPLPolicyChangesPage: { component: 'PremierPLPolicyChangesPage' }
    },
    {
        PremierPLPolicyChangesPage: PLPolicyChangesPage
    }
);

export { default as PremierPLPolicyChangeWizard } from './PremierPLPolicyChangeWizard';
